// extracted by mini-css-extract-plugin
export var contentBody = "_40-9";
export var headerImage = "_40-2";
export var imageButton = "_40-7";
export var imageButtonIcon = "_40-8";
export var imageHeader = "_40-4";
export var imageHeaderText = "_40-5";
export var imageOverlay = "_40-3";
export var imageTitle = "_40-6";
export var imageWrapper = "_40-1";
export var taskList = "_40-a";
export var widget = "_40-0";